import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.PERFORMANCE_SETTING_PRIORITY_REPORT)({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: {
                title: "setting_priority_report",
                to: APP_ROUTES_TO.PERFORMANCE_SETTING_PRIORITY_REPORT,
            },
            title: "setting_priority_report",
        },
        permissions: [PERMISSIONS.CALL_SETTING_PRIORITY_COUNTS],
    },
});

function RouteComponent() {
    return <Outlet />;
}
